import { render } from "./RsyAdImgContainer.vue?vue&type=template&id=6490653e&scoped=true"
import script from "./RsyAdImgContainer.vue?vue&type=script&lang=js"
export * from "./RsyAdImgContainer.vue?vue&type=script&lang=js"

import "./RsyAdImgContainer.vue?vue&type=style&index=0&id=6490653e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6490653e"]])

export default __exports__